import { motion } from 'framer-motion';
import { BookOpen, Globe, Buildings, GraduationCap, ArrowUpRight, Handshake, Microphone, Brain, ChartLineUp, Briefcase, UsersThree } from '@phosphor-icons/react';

const Projects = () => {
  const books = [
    {
      title: 'HACKIA TU DESPACHO',
      subtitle: 'Guía Práctica de IA para Juristas',
      description: 'Cómo Ángela y Sofía transformaron su despacho sin morir en el intento. La guía definitiva para implementar IA en el sector legal.',
      link: 'https://amzn.eu/d/0gNI5a7u',
      featured: true,
      year: '2025'
    },
    {
      title: 'La nueva abogacía',
      subtitle: 'Aranzadi La Ley (2024)',
      description: 'Guía de habilidades para liderar, convencer y triunfar en la abogacía moderna.',
      link: 'https://www.amazon.es/nueva-abogac%C3%ADa-habilidades-convencer-Monograf%C3%ADas/dp/8410789434?&linkCode=ll1&tag=tecnoabogad01-21&linkId=f359a97d312cdbfe55f0d9d771198945&language=es_ES&ref_=as_li_ss_tl',
      year: '2024'
    },
    {
      title: 'La Ciencia del Acuerdo',
      subtitle: 'Aranzadi La Ley (2025)',
      description: 'Negociación, Psicología y Estrategia para la abogacía actual.',
      link: 'https://www.amazon.es/acuerdo-negociar-abogac%C3%ADa-Gersti%C3%B3n-Despachos/dp/8410851296?dplnkId=9f18a73f-671b-4036-8a9b-b58827d99c88&nodl=1&linkCode=ll1&tag=tecnoabogad01-21&linkId=c7277e2a79d41fd0f0f81d9f0fc63e2b&language=es_ES&ref_=as_li_ss_tl',
      year: '2025'
    }
  ];

  const formacionAreas = [
    {
      icon: Microphone,
      title: 'Oratoria Jurídica',
      description: 'Domina el arte de hablar en público y persuadir en sala.',
      link: 'https://habilidadesabogados.es/habilidades/oratoria-juridica'
    },
    {
      icon: Brain,
      title: 'Inteligencia Emocional',
      description: 'Gestiona el estrés y mejora tus relaciones profesionales.',
      link: 'https://habilidadesabogados.es/habilidades/inteligencia-emocional'
    },
    {
      icon: Handshake,
      title: 'Negociación',
      description: 'Estrategias avanzadas para mejores acuerdos.',
      link: 'https://habilidadesabogados.es/habilidades/negociacion-juridica'
    },
    {
      icon: ChartLineUp,
      title: 'Marketing Legal',
      description: 'Posiciona tu despacho y construye marca personal.',
      link: 'https://habilidadesabogados.es/habilidades/marketing-legal'
    },
    {
      icon: UsersThree,
      title: 'Coaching Jurídico',
      description: 'Potencia tu rendimiento y liderazgo profesional.',
      link: 'https://habilidadesabogados.es/habilidades/coaching-juridico'
    },
    {
      icon: Briefcase,
      title: 'Gestión del Despacho',
      description: 'Productividad y organización eficiente.',
      link: 'https://habilidadesabogados.es/habilidades/gestion-del-despacho'
    }
  ];

  const platforms = [
    {
      icon: Buildings,
      title: 'Nexus Legal',
      subtitle: 'Socio Fundador (2024)',
      description: 'Plataforma colaborativa de servicios legales integrales.',
      link: 'https://nexuslegal.es/',
      featured: true
    },
    {
      icon: Buildings,
      title: 'Jurisciberia SL',
      subtitle: 'Fundador (2024)',
      description: 'Ciberseguridad, IA aplicada al derecho y ciberdelincuencia.'
    },
    {
      icon: Globe,
      title: 'Tecnoabogado',
      subtitle: 'Blog (2017)',
      description: 'Plataforma de referencia sobre tecnología, derecho y ciberseguridad.'
    },
    {
      icon: GraduationCap,
      title: 'IABogacia',
      subtitle: 'Formación IA (2025)',
      description: 'Formación especializada en IA aplicada al sector jurídico.'
    },
    {
      icon: Globe,
      title: 'Múltiples Web',
      subtitle: '10+ Sitios',
      description: 'Plataformas legales especializadas diseñadas y desarrolladas.'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.5 } }
  };

  return (
    <section id="projects" className="py-16 bg-[#050505] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          {/* Section Header */}
          <motion.div variants={itemVariants} className="mb-12">
            <p className="font-mono text-xs tracking-[0.2em] uppercase text-blue-500 mb-4">
              [04] Publicaciones & Proyectos
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-white">
              Formación, libros y plataformas
            </h2>
          </motion.div>

          {/* Formación Section - NEW */}
          <motion.div variants={itemVariants} className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <GraduationCap size={20} className="text-blue-500" weight="light" />
              <h3 className="font-mono text-sm text-white/50 uppercase tracking-wider">
                Formación para Abogados
              </h3>
              <a 
                href="https://habilidadesabogados.es/formacion" 
                target="_blank" 
                rel="noopener noreferrer"
                className="ml-auto font-mono text-xs text-blue-500 hover:text-blue-400 flex items-center gap-1"
              >
                Ver todo <ArrowUpRight size={14} />
              </a>
            </div>

            <div className="p-6 bg-[#0F0F0F] border border-white/10 mb-4">
              <p className="text-white/65 text-sm leading-relaxed mb-4">
                +15 años formando abogados en las competencias que marcan la diferencia: oratoria, inteligencia emocional, negociación y marketing legal. +10.000 abogados formados.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {formacionAreas.map((area, index) => (
                <a
                  key={index}
                  href={area.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group p-4 bg-[#0F0F0F] border border-white/10 hover:border-blue-500/30 transition-all"
                  data-testid={`formacion-${area.title.toLowerCase().replace(/\s/g, '-')}`}
                >
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center border border-blue-500/30 bg-blue-500/10 flex-shrink-0">
                      <area.icon size={16} className="text-blue-500" weight="light" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm font-medium text-white mb-1 group-hover:text-blue-400 transition-colors">
                        {area.title}
                      </h4>
                      <p className="text-xs text-white/40 leading-relaxed">
                        {area.description}
                      </p>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </motion.div>

          {/* Books Section */}
          <motion.div variants={itemVariants} className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <BookOpen size={20} className="text-blue-500" weight="light" />
              <h3 className="font-mono text-sm text-white/50 uppercase tracking-wider">
                Libros Publicados
              </h3>
            </div>

            <div className="grid md:grid-cols-3 gap-4">
              {books.map((book, index) => (
                <div
                  key={index}
                  className={`relative p-6 bg-[#0F0F0F] border card-hover ${
                    book.featured ? 'border-blue-500/50' : 'border-white/10'
                  }`}
                  data-testid={`book-${book.title.toLowerCase().replace(/\s/g, '-')}`}
                >
                  {book.featured && (
                    <div className="absolute top-0 right-0 bg-blue-600 text-white text-xs font-mono px-3 py-1">
                      NUEVO
                    </div>
                  )}
                  
                  <div className="flex items-start justify-between mb-4">
                    <div className="w-12 h-16 bg-gradient-to-br from-blue-600/20 to-blue-600/5 border border-blue-500/20 flex items-center justify-center">
                      <BookOpen size={24} className="text-blue-500/70" weight="light" />
                    </div>
                    <span className="font-mono text-xs text-white/30">{book.year}</span>
                  </div>
                  
                  <h4 className="text-lg font-medium text-white mb-1 leading-tight">
                    {book.title}
                  </h4>
                  
                  <p className="font-mono text-xs text-blue-500 uppercase tracking-wider mb-3">
                    {book.subtitle}
                  </p>
                  
                  <p className="text-sm text-white/50 leading-relaxed mb-4">
                    {book.description}
                  </p>
                  
                  <a
                    href={book.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 w-full justify-center px-4 py-2.5 bg-white/5 border border-white/10 text-white text-sm font-medium hover:bg-blue-600 hover:border-blue-600 transition-all"
                    data-testid={`book-link-${index}`}
                  >
                    Comprar en Amazon
                    <ArrowUpRight size={16} />
                  </a>
                </div>
              ))}
            </div>
          </motion.div>

          {/* Platforms Section */}
          <motion.div variants={itemVariants}>
            <div className="flex items-center gap-3 mb-6">
              <Globe size={20} className="text-blue-500" weight="light" />
              <h3 className="font-mono text-sm text-white/50 uppercase tracking-wider">
                Plataformas Digitales
              </h3>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
              {platforms.map((platform, index) => (
                <div
                  key={index}
                  className={`p-5 bg-[#0F0F0F] border card-hover ${
                    platform.featured ? 'border-blue-500/50 lg:col-span-1' : 'border-white/10'
                  }`}
                  data-testid={`platform-${platform.title.toLowerCase().replace(/\s/g, '-')}`}
                >
                  {platform.featured && (
                    <div className="text-xs font-mono text-blue-500 mb-2">DESTACADO</div>
                  )}
                  <div className="w-10 h-10 flex items-center justify-center border border-blue-500/30 bg-blue-500/10 mb-4">
                    <platform.icon size={20} className="text-blue-500" weight="light" />
                  </div>
                  
                  <h4 className="text-base font-medium text-white mb-1">
                    {platform.title}
                  </h4>
                  
                  <p className="font-mono text-xs text-white/40 uppercase mb-2">
                    {platform.subtitle}
                  </p>
                  
                  <p className="text-sm text-white/50 leading-relaxed mb-3">
                    {platform.description}
                  </p>

                  {platform.link && (
                    <a
                      href={platform.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 text-xs font-mono text-blue-500 hover:text-blue-400"
                    >
                      Visitar <ArrowUpRight size={12} />
                    </a>
                  )}
                </div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;
